import { Phone, Instagram, MapPin, Clock, Facebook, Mail } from "lucide-react";
import TikTokIcon from "./TikTokIcon";

const getThemeStyles = (variant) => {
  if (variant === 'red') return { bg: "bg-[#3A1515]", text: "text-[#D94F4F]" };
  if (variant === 'blue') return { bg: "bg-[#1A2F4A]", text: "text-[#93B8D8]" };
  return { bg: "bg-[#2D4A22]", text: "text-[#D9E8C8]" };
};

const ContactInfoItem = ({ href, target, rel, icon: Icon, svgIcon, label, value, testId, blue, red }) => {
  const variant = red ? 'red' : blue ? 'blue' : 'default';
  const { bg: iconBg, text: iconColor } = getThemeStyles(variant);

  const content = (
    <>
      <div className={`w-12 h-12 ${iconBg} rounded-xl flex items-center justify-center`}>
        {Icon && <Icon className={`w-5 h-5 ${iconColor}`} />}
        {svgIcon}
      </div>
      <div>
        <p className="text-sm text-[#A3A8A3]">{label}</p>
        <p className="text-lg font-semibold">{value}</p>
      </div>
    </>
  );

  if (href) {
    return (
      <a href={href} target={target} rel={rel} className="flex items-center gap-4 text-[#F2F0E9] hover:text-[#C4D6B0] transition-colors" data-testid={testId}>
        {content}
      </a>
    );
  }

  return (
    <div className="flex items-center gap-4 text-[#F2F0E9]" data-testid={testId}>
      {content}
    </div>
  );
};

const ContactInfo = () => (
  <div className="space-y-6">
    <ContactInfoItem
      href="tel:4196317496"
      icon={Phone}
      label="RSG Landscaping"
      value="419-631-7496"
      testId="contact-phone"
    />
    <ContactInfoItem
      href="tel:4196881398"
      icon={Phone}
      label="RSG Detailing"
      value="419-688-1398"
      testId="contact-detail-phone"
      blue
    />
    <ContactInfoItem
      href="https://instagram.com/rsg_landscaping"
      target="_blank"
      rel="noopener noreferrer"
      icon={Instagram}
      label="Instagram"
      value="@rsg_landscaping"
      testId="contact-instagram"
    />
    <ContactInfoItem
      href="https://tiktok.com/@rsg_landscaping"
      target="_blank"
      rel="noopener noreferrer"
      svgIcon={<TikTokIcon className="w-5 h-5 text-[#D9E8C8]" />}
      label="TikTok"
      value="@rsg_landscaping"
      testId="contact-tiktok"
    />
    <ContactInfoItem
      href="https://www.facebook.com/profile.php?id=61584987848634"
      target="_blank"
      rel="noopener noreferrer"
      icon={Facebook}
      label="Facebook"
      value="@rsg_landscaping"
      testId="contact-facebook"
    />
    <ContactInfoItem
      icon={MapPin}
      label="Located in"
      value="Bellville, Ohio"
    />
    <ContactInfoItem
      href="mailto:rsglandscapeservices@gmail.com"
      icon={Mail}
      label="Email us"
      value="rsglandscapeservices@gmail.com"
      testId="contact-email"
    />
    <ContactInfoItem
      icon={Clock}
      label="Quick Response"
      value="DM or call for a free quote"
    />
  </div>
);

export default ContactInfo;
